import Consts from '@/common/consts'
export default {
  EXECUTE_USER_LOGIN_VALIDATE_USERNAME: `${Consts.API_HOST_MAIN}/user/qryLoginKey`, // 校验用户名
  EXECUTE_USER_LOGIN_VALIDATE_PASSWORD: `${Consts.API_HOST_MAIN}/user/login`, // 校验密码
  EXECUTE_USER_LOGOUT: `${Consts.API_HOST_MAIN}/mewap/logout`, // 退出登录
  CHECK_INVITE_CODE: `${Consts.API_HOST_MAIN}/user/qryUpperDealer`, // 校验邀请码
  GET_UPER_USER_INFO: `${Consts.API_HOST_MAIN}/user/qryUpperInfo`, // 获取推荐人信息
  SEND_SMS_CODE: `${Consts.API_HOST_MAIN}/user/sendSmsCode`, // 发送短信验证码
  USER_REGISTER_KEY: `${Consts.API_HOST_MAIN}/user/qryRegisterKey`, // 获取用户注册所需的密钥
  USER_REGISTER: `${Consts.API_HOST_MAIN}/user/register`, // 用户注册
}
